import { render } from "./WCToastBody.vue?vue&type=template&id=72adeb03"
import script from "./WCToastBody.vue?vue&type=script&lang=js"
export * from "./WCToastBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__